import { RouteType } from "types/RouteType";
import commandCenterRoute from "./CommandCenter/commandCenter.Route";

/** Routes for the Home (command-center) area — spread into routesList.tsx. */
const homeRoutesList: RouteType[] = [...commandCenterRoute];

export default homeRoutesList;
